export default "__VITE_ASSET__DFQO$QrI__"